"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doughnut = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var Tooltip_1 = require("../Tooltip");
var RADIUS = 100 / (2 * Math.PI);
var getInitialDoughnutState = function () { return ({
    showingToolTip: false,
    tooltipX: undefined,
    tooltipY: undefined,
    tooltipText: undefined
}); };
var Doughnut = /** @class */ (function (_super) {
    __extends(Doughnut, _super);
    function Doughnut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = getInitialDoughnutState();
        _this.onTriggerTooltip = function (_a) {
            var x = _a.x, y = _a.y, tooltipText = _a.tooltip;
            if (!_this.state.showingToolTip) {
                _this.setState({
                    showingToolTip: true,
                    tooltipX: x,
                    tooltipY: y,
                    tooltipText: tooltipText
                });
            }
        };
        _this.onDisableTooltip = function () {
            setTimeout(function () { return _this.setState(getInitialDoughnutState()); }, 500);
        };
        return _this;
    }
    Doughnut.prototype.render = function () {
        var _this = this;
        var _a = this.props, sections = _a.sections, value = _a.value, label = _a.label, _b = _a.emptyColor, emptyColor = _b === void 0 ? theme_1.colors.black05 : _b, _c = _a.showToolTip, showToolTip = _c === void 0 ? false : _c;
        var initialOffset = 25;
        var lengthAccumulator = 0;
        return (React.createElement(DoughnutWrapper, null,
            React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 42 42", className: "donut" },
                React.createElement("circle", { className: "donut-hole", cx: "21", cy: "21", r: RADIUS, fill: "#fff" }),
                React.createElement("circle", { className: "donut-ring", cx: "21", cy: "21", r: RADIUS, fill: "transparent", stroke: emptyColor, strokeWidth: "3" }),
                sections && sections.map(function (section, i) {
                    var strokeDashoffset = 100 - lengthAccumulator + initialOffset;
                    lengthAccumulator = lengthAccumulator + section.percentage;
                    return (React.createElement(DoughnutCircleSection, { key: "section-" + section.percentage + "-" + section.percentage + "-" + i, color: section.color, percentage: section.percentage, tooltip: section.tooltip, strokeDashoffset: strokeDashoffset, showTooltip: showToolTip, onTriggerTooltip: _this.onTriggerTooltip, onDisableTooltip: _this.onDisableTooltip }));
                }),
                React.createElement("g", null,
                    value && (React.createElement(DoughnutValue, { x: "50%", y: "50%", textAnchor: "middle" }, value)),
                    label && (React.createElement(DoughnutLabel, { x: "50%", y: "50%", textAnchor: "middle" }, label)))),
            this.state.showingToolTip && (React.createElement(Tooltip_1.Tooltip, { variant: "simpleSmall", style: {
                    position: 'absolute',
                    top: this.state.tooltipY,
                    left: this.state.tooltipX
                } }, this.state.tooltipText))));
    };
    return Doughnut;
}(React.Component));
exports.Doughnut = Doughnut;
var baseCircleProps = {
    className: 'donut-segment',
    cx: 21,
    cy: 21,
    r: RADIUS,
    fill: 'transparent',
    strokeWidth: 3
};
var DoughnutCircleSection = /** @class */ (function (_super) {
    __extends(DoughnutCircleSection, _super);
    function DoughnutCircleSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseEnter = function (e) {
            var _a = _this.props, tooltip = _a.tooltip, percentage = _a.percentage;
            var clientX = e.clientX, clientY = e.clientY;
            _this.props.onTriggerTooltip({
                x: clientX,
                y: clientY,
                tooltip: tooltip || percentage + "%"
            });
        };
        _this.onMouseLeave = function (e) {
            _this.props.onDisableTooltip();
        };
        return _this;
    }
    DoughnutCircleSection.prototype.render = function () {
        var _this = this;
        var _a = this.props, strokeDashoffset = _a.strokeDashoffset, color = _a.color, percentage = _a.percentage, showTooltip = _a.showTooltip;
        var strokeDasharray = percentage + " " + (100 - percentage);
        return (React.createElement("circle", __assign({}, baseCircleProps, { stroke: color, strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset, onMouseEnter: function (e) {
                if (showTooltip) {
                    _this.onMouseEnter(e);
                }
            }, onMouseLeave: function (e) {
                if (showTooltip) {
                    _this.onMouseLeave(e);
                }
            } })));
    };
    return DoughnutCircleSection;
}(React.Component));
var DoughnutWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  background: ", ";\n  padding: 1.33rem 2rem;\n  border-radius: 0.33rem;\n"], ["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  background: ", ";\n  padding: 1.33rem 2rem;\n  border-radius: 0.33rem;\n"])), theme_1.colors.white);
var DoughnutValue = styled_1.default.text(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.3rem;\n  font-weight: bold;\n"], ["\n  font-size: 0.3rem;\n  font-weight: bold;\n"])));
var DoughnutLabel = styled_1.default.text(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 0.2rem;\n  opacity: 0.5;\n  transform: translateY(0.3rem);\n"], ["\n  font-size: 0.2rem;\n  opacity: 0.5;\n  transform: translateY(0.3rem);\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map